import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import ViewSearchBox from 'components/ViewSearchBox';
import ViewHorizontalNavigation from 'components/ViewHorizontalNavigation';
import ViewListToolbar from 'components/ViewListToolbar';
import ViewEventList from 'containers/ViewEventList';
import ViewSpinner from 'components/ViewSpinner';
import ViewToggleListToolbar from 'components/ViewToggleListToolbar';
import * as PopularEventsActions from 'actions/PopularEventsActions';
import * as OverviewEventsActions from 'actions/OverviewEventsActions';
import * as UiSportOverviewActions from 'actions/UiSportOverviewActions';
import * as SportTreeActions from 'actions/SportTreeActions';
import {
    showModal as ShowModal,
    hideModal as HideModal,
    setHighlightStatus as SetHighlightStatus,
    setLiveScoreStatus as SetLiveScoreStatus,
    setDannmarkItems as SetDannmarkItems,
} from '../actions/UiActions';
import * as VaixEventsAction from 'actions/VaixEventsActions';
import * as TrackingEventActions from 'actions/TrackingEventActions';
import { ModelService } from 'utils/ModelService';
import RestService from 'utils/RestService';
import { browserHistory } from 'react-router';
import {
    ANOTHER_GROUPS_ID,
    ANOTHER_SPORTS_ID,
    ANOTHER_SPORTS_PATH,
    ANOTHER_GROUPS_PATH,
    CAMPAIGNS_COMPARE_WITH,
    LIVE_CASINO,
    LIVE_COMPETITORS_ORDER,
    LIVE_ID,
    REST_EUROPE_ID,
    REST_WORLD_ID,
    SEARCH_LETTER_COUNT,
    SEO_SPORTS,
    SOON_ID,
    BIG_NINE,
    SPORT_GROUPS_ID,
} from 'constants/appConfig';
import cookie from 'react-cookies';
import { ParsproService } from 'utils/ParsproService';
import TerminalRestService from 'utils/TerminalRestService';
import {
    sortEventsByCompetitionAndGroupPriority,
    validateUrlParams,
} from 'utils/Helper';
import 'css/HomePage.scss';
import ViewCampaignListItem from 'components/ViewCampaignListItem';
import * as AuthActions from 'actions/AuthActions';
import {
    desktopOnly,
    detectMobile,
    isTerminal,
    scrollToTop,
} from 'utils/UiHelper';
import UserService from '../utils/UserService';
import {
    addVaixLiveFavoriteEvents as AddVaixLiveFavoriteEvents,
    getLivePopularVaixEvents as GetLivePopularVaixEvents,
    setLiveVaixPopularFetchedStatus as SetLiveVaixPopularFetchedStatus,
} from '../actions/LiveEventsActions';
import GroupEventItem from './EventItemContainer/GroupEventItem';
import { checkURL } from '../utils/Helper';
import Wrapper from '../ui/Wrapper';
import HorizontalNavigationSkeleton from '../components/SkeletonUI/HorizontalNavigationSkeleton/HorizontalNavigationSkeleton';
import SearchFieldSkeleton from '../components/SkeletonUI/SearchFieldSkeleton/SearchFieldSkeleton';
import ViewEventListSkeleton from '../components/SkeletonUI/ViewEventListSkeleton/ViewEventListSkeleton';
import { LoadableContainer } from '../features/HomeContainer/HOCs/LoadableContainer';
import CampaignSkeleton from '../components/SkeletonUI/CampaignSkeleton/CampaignSkeleton';
import AndetPageSkeleton from '../components/SkeletonUI/AndetPageSkeleton/AndetPageSkeleton';
import Combos from '../features/Combos/Combos';
import CustomBetRecommendation from 'features/CustomBetRecommendation/CustomBetRecommendation';
import EventsHighlights from 'features/EventsHighlights/EventsHighlights';

const HomeContainerNew = (props) => {
    const [popularLimit, setPopularLimit] = useState(25);
    const [livePopular, setLivePopular] = useState([]);
    const [livePopularOurSide, setLivePopularOurSide] = useState([]);
    const [activeSport, setActiveSport] = useState(null);
    const [activeGroup, setActiveGroup] = useState(null);
    const [activeTournament, setActiveTournament] = useState(null);
    const [fetchSearchTimeoutId, setFetchSearchTimeoutId] = useState(300);
    const [
        popularLiveEventsOurSideFetched,
        setPopularLiveEventsOurSideFetched,
    ] = useState(false);
    const [isInitialPopularLiveReady, setIsInitialPopularLiveReady] = useState(
        false
    );
    const [isInitialPageLoad, setIsInitialPageLoad] = useState(true);
    const [restEuropeItems, setRestEuropeItems] = useState([]);
    const [restWorldItems, setRestWorldItems] = useState([]);
    const [isGameItemsLoading, setIsGameItemsLoading] = useState(true);

    const isMobile = detectMobile();
    const isDesktop = desktopOnly();

    const pathnameArr = window.location.pathname.split('/');
    const pathname = pathnameArr.slice(1);

    const isRestenGroup = ['resten-af-europa', 'resten-af-verden'].includes(
        pathname[2]
    );
    const isAnotherPage =
        pathname[2] === ANOTHER_GROUPS_PATH ||
        pathname[1] === ANOTHER_SPORTS_PATH;

    const isSportPage =
        SEO_SPORTS.includes(pathname[1]) && pathname[1] !== 'andet-sport';
    const hasHomePage = !isSportPage && !isAnotherPage;
    const showGeneralNavigation =
        hasHomePage || pathname[1] === ANOTHER_SPORTS_PATH || !isSportPage;

    const liveEventSearchFileds = ['eventName', 'competition'];
    const popularLimitDef = 25;

    const isTWA = Boolean(JSON.parse(window.localStorage.getItem('isTWA')));

    let timer = null;

    const liveCompetitionIdsOrder = LIVE_COMPETITORS_ORDER;

    const liveGroupsIdsOrder = [
        SPORT_GROUPS_ID.INTERNATIONAL,
        SPORT_GROUPS_ID.INTERNATIONAL_CLUB,
    ];

    const checkUserName = () => {
        if (props.auth?.user?.userId) {
            UserService.InfoGet().then((res) => {
                if (res.success) {
                    let { limits } = res.data;

                    if (
                        !limits.dailyAmountLimit &&
                        !limits.monthlyAmountLimit &&
                        !limits.weeklyAmountLimit
                    ) {
                        props.showModal('FAST_DEPOSIT_LIMIT');
                    }
                }
            });
        }
    };

    useEffect(
        () => {
            if (props.sportTree.fetched && !props.sportTree.error) {
                setIsInitialPageLoad(false);
            }
        },
        [props.sportTree.fetched, props.sportTree.error]
    );

    useEffect(
        () => {
            if (!props.sportTree.fetched && !props.sportTree.pending) {
                props.sportTreeActions.getSportTree();
            }
        },
        [props.sportTree.fetched, props.sportTree.pending]
    );

    useEffect(
        () => {
            const pathname = window.location.pathname;
            const shouldTrigger = /^(\/|\/sport|\/sport\/)$/.test(pathname);
            if (
                shouldTrigger &&
                props.popularEvents.fetched &&
                props.popularEvents.data.length > 0 &&
                props.popularEvents.vaixEventsFetched
            ) {
                const externalIds = props.popularEvents.data.map((event) => ({
                    id: `sr:match:${event.externalId}`,
                }));
                props.trackImpressionEvent(
                    'impressions:events',
                    externalIds,
                    'sr-widget:prematchbetrecommendation.eventlist:recommended',
                    '/home',
                    props.auth?.user?.userId || 0
                );
            }
        },
        [
            props.popularEvents.fetched,
            props.popularEvents.vaixEventsFetched,
            props.auth?.user?.userId,
        ]
    );

    useEffect(
        () => {
            const pathname = window.location.pathname;
            const shouldTrigger = /^(\/|\/sport|\/sport\/)$/.test(pathname);
            if (
                shouldTrigger &&
                livePopular.length > 0 &&
                props.liveEvents.vaixPopularEventsFetched &&
                props.liveEvents.fetched
            ) {
                const externalIds = livePopular.map((event) => ({
                    id: `sr:match:${event.externalId}`,
                }));
                props.trackImpressionEvent(
                    'impressions:events',
                    externalIds,
                    'sr-widget:livebetrecommendation.eventlist:recommended',
                    '/home',
                    props.auth?.user?.userId || 0
                );
            }
        },
        [livePopular.length]
    );

    useEffect(
        () => {
            props.setLiveScoreStatus(true);
            props.authActions.updateBalance();
            if (!props.popularEvents.fetched) {
                props.popularEventsActions.getPopularEvents(
                    false,
                    props.auth?.user?.userId
                );
            }

            if (window.dataLayer) {
                let isPresentPageView = window.dataLayer.find(
                    (ev) => ev.event === 'page_view'
                );
                if (typeof isPresentPageView === 'undefined') {
                    window.dataLayer.push({
                        event: 'page_view',
                        type: 'sport',
                        userId: props.auth?.user?.userId || 0,
                    });
                }
            }

            setStateByPathname(
                props.sportTree,
                props.routing.locationBeforeTransitions.pathname
            );

            if (isTerminal()) {
                timer = setInterval(() => {
                    getPopularLiveEvents(props.auth?.user?.userId);
                }, 60000);
            }

            scrollToTop();

            checkUserName();
        },
        [props.sportTree.fetched]
    );

    useEffect(() => {
        RestService.GameItems((data) => {
            if (data && data[2]) {
                setRestEuropeItems(data[2].items);
                setRestWorldItems(data[4].items);
                props.setDannmarkItems(data[6].items);
            }
            setIsGameItemsLoading(false);
        });

        return () => {
            window.clearInterval(timer);
            window.clearTimeout(fetchSearchTimeoutId);

            timer = null;
        };
    }, []);

    useEffect(
        () => {
            if (props.auth.showForgotPassword === true) {
                props.showModal('FORGOT_PASSWORD');
                setTimeout(() => {
                    props.authActions.changeStatusForForgotPassword(false);
                }, 50);
            }
        },
        [props.auth.showForgotPassword]
    );

    useEffect(
        () => {
            if (props.liveEvents.vaixPopularEventsFetched) {
                props.setLiveVaixPopularFetchedStatus(false);
                if (props.liveEvents.vaixPopularEvents.length > 0) {
                    setLivePopular(props.liveEvents.vaixPopularEvents);
                    setIsInitialPopularLiveReady(true);
                } else {
                    if (!popularLiveEventsOurSideFetched) {
                        getPopularLiveEventsOurSide();
                    }
                }
            }
        },
        [props.liveEvents.vaixPopularEventsFetched]
    );

    /*useEffect(
        () => {
            //events for live section Anbefalede
            if (props.vaixEvents.vaixFavoriteEventsShouldBeUpdated) {
                if (props.vaixEvents.vaixLiveFavoriteEventsIds.length > 0) {
                    props.addVaixLiveFavoriteEvents(
                        props.vaixEvents.vaixLiveFavoriteEventsIds
                    );
                    props.vaixEventsActions.updateVaixLiveEventsComponentStatus(
                        false
                    );
                } else {
                    props.vaixEventsActions.updateVaixLiveEventsComponentStatus(
                        false
                    );
                    props.liveEventsActions.setLiveVaixFavoriteFetchedStatus(
                        true
                    );
                }
            }
        },
        [props.vaixEvents.vaixFavoriteEventsShouldBeUpdated]
    );*/

    useEffect(
        () => {
            if (props.auth?.user?.userId) {
                checkUserName();
            }
            props.popularEventsActions.getPopularEvents(
                false,
                props.auth?.user?.userId
            );
            getPopularLiveEvents(props.auth?.user?.userId);
            checkMitIdRedirect();
        },
        [props.auth?.user?.userId]
    );

    useEffect(
        () => {
            if (livePopular?.length === 0) {
                getPopularLiveEvents(props.auth?.user?.userId);
            }
        },
        [props.liveEvents?.array?.length]
    );

    useEffect(
        () => {
            setStateByPathname(
                props.sportTree,
                props.routing.locationBeforeTransitions.pathname
            );
        },
        [
            props.routing.locationBeforeTransitions.pathname,
            props.sportTree.fetched,
        ]
    );

    useEffect(
        () => {
            if (livePopularOurSide.length > 0) {
                setLivePopularOurSide(setLivePopularEvents(livePopularOurSide));
            }
        },
        [props.liveEvents?.data]
    );

    useEffect(
        () => {
            if (
                window.location.pathname === '/sport/opret-konto' &&
                !props.modals['SIGNUP_MODAL']
            ) {
                props.showModal('SIGNUP_MODAL');
            }
            if (checkURL('forgot-password')) {
                isMobile && props.hideModal('LOGIN_MOBILE');
                props.showModal('FORGOT_PASSWORD');
            }
            if (checkURL('forgot-pin')) {
                props.showModal('FORGOT_PASSWORD', { isPinLogin: true });
            }
            checkMitIdRedirect();
        },
        [window.location.pathname]
    );

    const checkMitIdRedirect = () => {
        if (checkURL('forgotpassword') && props?.auth?.user?.userId) {
            if (
                props.auth?.user &&
                !props.auth?.loginPending &&
                !props.auth?.sessionPending
            ) {
                props.showModal('RESTORE_PASSWORD');
            } else {
                browserHistory.push('/sport/404');
            }
        }

        if (checkURL('forgotpin') && props?.auth?.user?.userId) {
            if (
                props.auth?.user &&
                !props.auth?.loginPending &&
                !props.auth?.sessionPending
            ) {
                props.showModal('PIN_LOGIN', {
                    mode: 'restore-pin',
                });
            } else {
                browserHistory.push('/sport/404');
            }
        }
    };

    const setStateByPathname = (sportTree, pathname) => {
        let pathArr = pathname.split('/');
        if (pathArr[1] !== '' && SEO_SPORTS.indexOf(pathArr[1]) > -1) {
            let activeSportLoc = null;
            let activeGroupLoc = null;
            let activeTournamentLoc = null;

            if (pathArr[1]) {
                activeSportLoc = sportTree.sportData.find(
                    (sport) => validateUrlParams(sport.name) === pathArr[1]
                );

                if (activeSportLoc) {
                    if (pathArr[2]) {
                        if (!isRestenGroup || pathArr[1] !== 'fodbold') {
                            activeGroupLoc = activeSportLoc.itemList.find(
                                (group) =>
                                    validateUrlParams(group.name) === pathArr[2]
                            );
                        }
                    } else {
                        activeGroupLoc = activeSportLoc.itemList[0];
                    }

                    if (
                        activeGroupLoc &&
                        (!isRestenGroup || pathArr[1] !== 'fodbold')
                    ) {
                        if (activeGroupLoc !== activeGroup) {
                            props.overviewEventsActions.getPreEventsByGroupId(
                                activeGroupLoc.id
                            );
                        }

                        if (pathArr[3]) {
                            activeTournamentLoc = activeGroupLoc.itemList.find(
                                (tournament) =>
                                    validateUrlParams(tournament.name) ===
                                    pathArr[3]
                            );
                        } else {
                            //activeTournamentLoc = activeGroupLoc.itemList[0];
                        }
                    }
                }
            }

            setActiveSport(activeSportLoc);
            setActiveGroup(activeGroupLoc);
            setActiveTournament(activeTournamentLoc);
        }
    };

    const setLivePopularEvents = (events) => {
        let liveEvents = props.liveEvents;
        return (events || []).map((event) => {
            if (event?.eventId) {
                return liveEvents.fetched &&
                    liveEvents.eventSport[event.eventId]
                    ? liveEvents.data[liveEvents.eventSport[event.eventId]][
                          event.eventId
                      ]
                    : event;
            }
        });
    };

    const getPopularLiveEventsOurSide = () => {
        //we set this status to prevent multiple requests
        if (!popularLiveEventsOurSideFetched) {
            setPopularLiveEventsOurSideFetched(true);
            ParsproService.getLivePopularEvents()
                .then((res) => {
                    const { data } = res;
                    if (data) {
                        setLivePopularOurSide(setLivePopularEvents(res.data));
                    }
                    setTimeout(
                        () => setPopularLiveEventsOurSideFetched(false),
                        60000
                    );
                })
                .finally(() => setIsInitialPopularLiveReady(true));
        }
    };

    const getPopularLiveEvents = () => {
        if (isTerminal()) {
            TerminalRestService.getLivePopularEvents((res) => {
                const { data } = res;
                if (data) {
                    setLivePopularOurSide(setLivePopularEvents(data));
                }
            });
        } else {
            if (props.liveEvents.vaixPopularEventsFetched) {
                props.getLivePopularVaixEvents(props.auth?.user?.userId);
            }
        }
    };

    const onSearchTextHandler = (searchText) => {
        window.clearTimeout(fetchSearchTimeoutId);
        props.uiSportOverviewActions.search(searchText);

        if (
            searchText &&
            searchText.length >= SEARCH_LETTER_COUNT &&
            props.overviewSearchEvents.pending === false
        ) {
            setFetchSearchTimeoutId(
                window.setTimeout(() => {
                    props.overviewEventsActions.searchByQuery(searchText);
                }, 300)
            );
        } else {
            props.overviewEventsActions.clearSearch();
        }
    };

    const onClickBackBtn = () => {
        props.uiSportOverviewActions.search('');
        props.overviewEventsActions.clearSearch();
        if (activeSport?.priority === 0) {
            browserHistory.push(`/sport/${ANOTHER_SPORTS_PATH}`);
        } else {
            browserHistory.push('/sport/');
        }
    };

    const horizontalNavClickHandler = (item) => {
        let pathnameLoc = window.location.pathname.split('/');
        let pathname = pathnameLoc.slice(1);
        let basePath = pathname[1];
        const listNotEmpty = item.itemList && item.itemList?.length > 0;
        const priorityItems = listNotEmpty
            ? item.itemList.filter(
                  (itemEvent) => itemEvent.priority && itemEvent.count > 0
              )
            : [];

        let newPath = '';

        if (basePath === '' || item.type === 1) {
            if (listNotEmpty && !priorityItems.length) {
                newPath = `/sport/${validateUrlParams(
                    item.name
                )}/${ANOTHER_GROUPS_PATH}`;
            } else if (priorityItems.length) {
                newPath = `/sport/${validateUrlParams(
                    item.name
                )}/${validateUrlParams(priorityItems[0].name)}`;
            } else {
                newPath = `/sport/${validateUrlParams(item.name)}`;
            }
        } else if (item.type === 2) {
            newPath = `/sport/${basePath}/${validateUrlParams(item.name)}`;
        } else if (item.type === 3) {
            newPath = `/sport/${basePath}/${pathname[2]}/${validateUrlParams(
                item.name
            )}`;
        } else if (item.id === ANOTHER_SPORTS_ID) {
            newPath = `/sport/${ANOTHER_SPORTS_PATH}`;
        } else if (item.id === REST_EUROPE_ID) {
            newPath = `/sport/${basePath}/resten-af-europa`;
        } else if (item.id === REST_WORLD_ID) {
            newPath = `/sport/${basePath}/resten-af-verden`;
        } else if (item.id === '0') {
            newPath = `/sport/${basePath}`;
        } else if (item.id === ANOTHER_GROUPS_ID) {
            newPath = `/sport/${basePath}/${ANOTHER_GROUPS_PATH}`;
        }

        if (newPath) {
            browserHistory.push(newPath);
        }

        props.uiSportOverviewActions.setOverviewParams({
            overviewBackBtn: true,
        });
    };

    const toggleHandler = (item) => {
        let pathnameLoc = window.location.pathname.split('/');
        let pathname = pathnameLoc.slice(1);

        if (pathname[1] && pathname[1] === ANOTHER_SPORTS_PATH) {
            browserHistory.push('/sport/' + validateUrlParams(item.name));
        } else if (pathname[2]) {
            if (pathname[2] === 'resten-af-europa') {
                browserHistory.push(
                    '/sport/' + pathname[1] + '/' + validateUrlParams(item.name)
                );
            } else if (pathname[2] === 'resten-af-verden') {
                browserHistory.push(
                    '/sport/' + pathname[1] + '/' + validateUrlParams(item.name)
                );
            } else if (pathname[2] === ANOTHER_GROUPS_PATH) {
                browserHistory.push(
                    '/sport/' + pathname[1] + '/' + validateUrlParams(item.name)
                );
            }
        } else if (pathname[1] === 'fodbold' && !pathname[2]) {
            browserHistory.push(
                '/sport/fodbold/' + validateUrlParams(item.title)
            );
        }

        props.uiSportOverviewActions.setOverviewParams({
            overviewBackBtn: true,
        });
    };

    const onCloseHighlightHandler = () => {
        let d = new Date();

        d.setTime(d.getTime() + 24 * 60 * 60 * 1000);

        cookie.save('hide-highlights', 'true', {
            path: '/',
            expires: d,
        });

        props.setHighlightStatus(false);
    };

    const onLinkClickHandler = (key) => {
        if (key === 'live') {
            browserHistory.push('/sport/live');
        } else {
            setPopularLimit(
                popularLimitDef === popularLimit ? 0 : popularLimit
            );
        }
    };

    const _getPopularEventsBySportId = (sportId) => {
        return props.popularEvents.data
            .sort((a, b) => a.eventId - b.eventId)
            .filter((item) => {
                if (item.sportId === sportId) {
                    return item;
                }

                return null;
            });
    };

    const getPopularEventsView = (
        pending,
        fetched,
        data,
        vaixIsFetched,
        sportData
    ) => {
        if (!props.popularEvents.pending && props.popularEvents.fetched) {
            if (vaixIsFetched && data.length > 0) {
                let {
                    sortedTypeOfSports,
                    groupedEvents,
                } = ModelService.getVaixModelBySportId(data);

                return sortedTypeOfSports.map((group, key) => (
                    <GroupEventItem
                        events={groupedEvents[group]}
                        key={`${key}_popular_${group}`}
                        showFavorites={false}
                        trackClickEvent={props.trackClickEvent}
                        trackImpressionEvent={props.trackImpressionEvent}
                        userId={props.auth.user?.userId}
                    />
                ));
            } else {
                if (!vaixIsFetched && data.length > 0) {
                    return (
                        <ViewEventList
                            events={ModelService.getSportTreeWithGroupedByCompetitions(
                                sportData,
                                data,
                                'array',
                                popularLimit,
                                null,
                                'null'
                            )}
                        />
                    );
                } else {
                    return null;
                }
            }
        }
    };

    const isLoginOpen = () =>
        props.modals['LOGIN_MOBILE'] ||
        window.location.pathname === '/log-ind' ||
        window.location.pathname === '/sport/log-ind';

    const getAnotherSportsList = () => {
        let anotherSports = props.sportTree.sportData.filter(
            (item) => !item.priority
        );

        return (
            <div className="another-sports">
                {anotherSports
                    .sort((a, b) => {
                        if (a.name > b.name) {
                            return 1;
                        }

                        if (a.name < b.name) {
                            return -1;
                        }

                        return 0;
                    })
                    .map((item, index) => (
                        <ViewToggleListToolbar
                            key={index}
                            title={item.name}
                            type="right-arrow"
                            tournamentId={item.id}
                            toggleHandler={() => toggleHandler(item)}
                        />
                    ))}
            </div>
        );
    };

    const getLiveEventsView = () => {
        if (!props.sportTree.fetched || !hasHomePage) {
            return null;
        }

        let overviewLiveView = null;

        let {
            sortedTypeOfSports,
            groupedEvents,
        } = ModelService.getVaixModelBySportId(livePopular);

        if (sortedTypeOfSports.length > 0) {
            overviewLiveView = sortedTypeOfSports.map((group, key) => (
                <GroupEventItem
                    events={groupedEvents[group]}
                    key={`${key}_live_${group}`}
                    showFavorites={false}
                    trackClickEvent={props.trackClickEvent}
                    trackImpressionEvent={props.trackImpressionEvent}
                    userId={props.auth.user?.userId}
                />
            ));
        } else {
            if (livePopularOurSide.length > 0) {
                let livePopularEvents = livePopularOurSide || [];
                let livePopularFilteredEvents = sortEventsByCompetitionAndGroupPriority(
                    livePopularEvents,
                    liveCompetitionIdsOrder,
                    liveGroupsIdsOrder
                ).filter((ev) => ev.live && ev.liveScore);
                overviewLiveView = (
                    <ViewEventList
                        events={ModelService.getSportTreeWithGroupedByCompetitions(
                            props.sportTree.sportData,
                            livePopularFilteredEvents,
                            'array',
                            5
                        )}
                    />
                );
            } else {
                overviewLiveView = null;
            }
        }

        const hasLivePopularData =
            (props.ui.showLiveSection &&
                overviewLiveView &&
                livePopular &&
                livePopular.length > 0) ||
            (props.ui.showLiveSection &&
                overviewLiveView &&
                livePopularOurSide &&
                livePopularOurSide.length > 0);

        return hasLivePopularData ? (
            <div className="live-section-events">
                <ViewListToolbar
                    image={true}
                    title="Live kampe"
                    onLinkClickHandler={() => onLinkClickHandler('live')}
                />{' '}
                {overviewLiveView}
            </div>
        ) : null;
    };

    const getFootballView = (pathname) => {
        let events = []; // TODO this._getPopularEventsBySportId(activeSportLoc.id);

        if (events.length > 0 || isRestenGroup || !pathname[2]) {
            if (!pathname[2]) {
                if (props.overviewEvents.fetched) {
                    return (
                        <ViewEventList
                            events={ModelService.getSportTree(
                                props.sportTree.sportData,
                                props.overviewEvents.data,
                                'array',
                                0,
                                null,
                                'sportId'
                            )}
                            listStyle="toggle"
                            tournamentId={
                                activeTournament ? activeTournament.id : 0
                            }
                        />
                    );
                }
            } else {
                if (pathname[2] === 'resten-af-europa') {
                    let restOfEurope = [];

                    activeSport.itemList.forEach((item) => {
                        restEuropeItems.forEach((europeItem) => {
                            if (europeItem.item_id === item.id.toString()) {
                                restOfEurope.push(item);
                            }
                        });
                    });

                    return (
                        <div className="resten-af-europa">
                            {restOfEurope
                                .sort((a, b) => {
                                    if (a.name < b.name) return -1;
                                    if (a.name > b.name) return 1;
                                    return 0;
                                })
                                .map((item) => (
                                    <ViewToggleListToolbar
                                        key={item.id}
                                        title={item.name}
                                        type="right-arrow"
                                        tournamentId={item.id}
                                        toggleHandler={() =>
                                            toggleHandler(item)
                                        }
                                    />
                                ))}
                        </div>
                    );
                } else if (pathname[2] === 'resten-af-verden') {
                    let restOfWorld = [];
                    activeSport.itemList.forEach((item) => {
                        restWorldItems.forEach((worldItem) => {
                            if (worldItem.item_id === item.id.toString()) {
                                restOfWorld.push(item);
                            }
                        });
                    });

                    return (
                        <div className="resten-af-verden">
                            {restOfWorld
                                .sort((a, b) => {
                                    if (a.name < b.name) return -1;
                                    if (a.name > b.name) return 1;
                                    return 0;
                                })
                                .map((item) => (
                                    <ViewToggleListToolbar
                                        key={item.id}
                                        title={item.name}
                                        type="right-arrow"
                                        tournamentId={item.id}
                                        toggleHandler={() =>
                                            toggleHandler(item)
                                        }
                                    />
                                ))}
                        </div>
                    );
                } else {
                    if (props.overviewEvents.fetched) {
                        return (
                            <ViewEventList
                                events={ModelService.getSportTree(
                                    props.sportTree.sportData,
                                    props.overviewEvents.data,
                                    'array',
                                    0,
                                    null,
                                    'sportId'
                                )}
                                listStyle="toggle"
                                tournamentId={
                                    activeTournament ? activeTournament.id : 0
                                }
                            />
                        );
                    }
                }
            }
        } else {
            if (props.overviewEvents.fetched) {
                return (
                    <ViewEventList
                        events={ModelService.getSportTree(
                            props.sportTree.sportData,
                            props.overviewEvents.data,
                            'array',
                            0,
                            null,
                            'sportId'
                        )}
                        listStyle="toggle"
                        tournamentId={
                            activeTournament ? activeTournament.id : 0
                        }
                    />
                );
            }
        }
    };

    const getActiveSportView = (pathname) => {
        let events = _getPopularEventsBySportId(activeSport.id);
        if (events.length > 0 && !pathname[2]) {
            return (
                <ViewEventList
                    events={ModelService.getSportTree(
                        props.sportTree.sportData,
                        events,
                        'array',
                        0,
                        null,
                        'sportId'
                    )}
                />
            );
        } else {
            if (
                pathname[2] !== ANOTHER_GROUPS_PATH &&
                props.overviewEvents.fetched
            ) {
                return (
                    <ViewEventList
                        events={ModelService.getSportTree(
                            props.sportTree.sportData,
                            props.overviewEvents.data,
                            'array',
                            0,
                            null,
                            'sportId'
                        )}
                        listStyle="toggle"
                        tournamentId={
                            activeTournament ? activeTournament.id : 0
                        }
                    />
                );
            }
        }

        if (pathname[2] === ANOTHER_GROUPS_PATH) {
            let anotherGroups = activeSport.itemList.filter(
                (currentItem) =>
                    currentItem.priority === 0 && currentItem.count > 0
            );
            return (
                <div className="andet">
                    {anotherGroups.map((item) => (
                        <ViewToggleListToolbar
                            key={item.id}
                            title={item.name}
                            type="right-arrow"
                            tournamentId={item.id}
                            toggleHandler={() => toggleHandler(item)}
                        />
                    ))}
                </div>
            );
        }

        return null;
    };

    const getSportPageView = (pathname) => {
        let sportListView = null;

        const activeSportLoc = activeSport;
        const isFootball = activeSportLoc && activeSportLoc.id === 1;

        if (isFootball) {
            sportListView = getFootballView(pathname);
        } else if (activeSport) {
            sportListView = getActiveSportView(pathname);
        }

        return sportListView;
    };

    const getFrontPageView = () => {
        return (
            <div>
                <Wrapper padding={'0'} margin={'0 0 20px'}>
                    <ViewListToolbar
                        title={`Anbefalede kampe`}
                        onLinkClickHandler={() =>
                            onLinkClickHandler('xpopular')
                        }
                    />{' '}
                    {getPopularEventsView(
                        props.popularEvents.pending,
                        props.popularEvents.fetched,
                        props.popularEvents.data,
                        props.popularEvents.vaixEventsFetched,
                        props.sportTree.sportData
                    )}
                </Wrapper>
            </div>
        );
    };

    const getView = (pathname) => {
        if (!props.sportTree.fetched || props.sportTree.error) {
            return null;
        }

        if (isSportPage) {
            return getSportPageView(pathname);
        } else if (!isTerminal() && pathname[1] === ANOTHER_SPORTS_PATH) {
            return getAnotherSportsList();
        } else {
            return getFrontPageView();
        }
    };

    const getGeneralNavigationOptions = () => {
        let items = [];
        let selectedId = 'none';

        if (!isTerminal()) {
            items = [
                {
                    id: LIVE_ID,
                    name: 'LIVE',
                },
                {
                    id: SOON_ID,
                    name: 'Starter snart',
                },
                ...(!isTWA
                    ? [
                          {
                              id: LIVE_CASINO,
                              name: 'Live casino',
                          },
                      ]
                    : []),
                ...props.sportTree.sportData
                    .filter((item) => item.priority && item.count > 0)
                    .sort((a, b) => a.priority - b.priority),
                {
                    name: 'Andet sport',
                    id: ANOTHER_SPORTS_ID,
                },
            ];
            if (!isMobile) {
                let big9 = {
                    id: BIG_NINE,
                    name: 'Big 9',
                };

                let index = items.findIndex((item) => item.name === 'Fodbold');

                items.splice(index + 1, 0, big9);
            }

            if (pathname[1] === ANOTHER_SPORTS_PATH) {
                selectedId = ANOTHER_SPORTS_ID;
            }
        } else {
            items = [
                ...props.sportTree.sportData
                    .filter((item) => item.priority && item.count > 0)
                    .sort((a, b) => a.priority - b.priority),
                {
                    name: 'Andet sport',
                    id: ANOTHER_SPORTS_ID,
                },
            ];
        }

        return { items, selectedId };
    };

    const getSportPageNavigationOptions = (pathname) => {
        let selectedId = 'none';
        let selectedSport = null;

        let activeSportLoc = activeSport;

        let itemList =
            activeSportLoc && activeSportLoc.itemList
                ? activeSportLoc.itemList.filter((item) => item.count > 0)
                : [];
        let isNeedRestLabels = false;
        const isFootball = activeSportLoc?.id === 1;

        if (isFootball) {
            itemList = itemList.filter((item) => item.priority > 0);

            isNeedRestLabels = true;
            const restLabels = [
                {
                    id: REST_EUROPE_ID,
                    name: 'Resten af<br> Europa',
                },
                {
                    id: REST_WORLD_ID,
                    name: 'Resten af<br> Verden',
                },
            ];

            let events = []; // TODO this._getPopularEventsBySportId(activeSportLoc.id);

            if (events.length > 0 || isRestenGroup || !pathname[2]) {
                if (isNeedRestLabels) {
                    selectedSport = {
                        ...activeSportLoc,
                        itemList: [
                            ...itemList.filter((item) => {
                                return item.count > 0 && item.priority !== 0;
                            }),
                            ...restLabels,
                        ],
                    };
                } else {
                    selectedSport = {
                        ...activeSportLoc,
                    };
                }

                if (!pathname[2]) {
                    selectedId = activeGroup ? activeGroup.id.toString() : null;
                } else {
                    if (pathname[2] === 'resten-af-europa') {
                        selectedId = REST_EUROPE_ID;
                    } else if (pathname[2] === 'resten-af-verden') {
                        selectedId = REST_WORLD_ID;
                    } else {
                        selectedId = activeGroup
                            ? activeGroup.id.toString()
                            : null;
                    }
                }
            } else {
                if (isNeedRestLabels) {
                    selectedSport = {
                        ...activeSport,
                        itemList: [
                            ...itemList.filter((item) => item.count > 0),
                            ...restLabels,
                        ],
                    };
                } else {
                    selectedSport = {
                        ...activeSport,
                        itemList: [
                            ...activeSport.itemList.filter(
                                (item) => item.count > 0
                            ),
                        ],
                    };
                }

                if (pathname[1] === ANOTHER_SPORTS_PATH) {
                    selectedId = ANOTHER_SPORTS_ID;
                } else {
                    if (activeGroup) {
                        selectedId = activeGroup.id.toString();
                    } else {
                        selectedId = '0';
                    }
                }
            }
        } else if (activeSport) {
            if (itemList.length > 0) {
                const priorityList = itemList
                    .filter((item) => item.priority > 0)
                    .sort((a, b) => a.priority - b.priority);

                selectedSport = {
                    ...activeSport,
                    itemList:
                        priorityList.length === itemList.length
                            ? priorityList
                            : [
                                  ...priorityList,
                                  {
                                      id: ANOTHER_GROUPS_ID,
                                      name: 'Andet',
                                  },
                              ],
                };
            }

            let events = _getPopularEventsBySportId(activeSport.id);
            if (events.length > 0 && !pathname[2]) {
                selectedId = '0';
            }

            if (pathname[2] === ANOTHER_GROUPS_PATH) {
                selectedId = ANOTHER_GROUPS_ID;
            } else {
                selectedId = activeGroup ? activeGroup.id.toString() : null;
            }
        }

        return { selectedSport, selectedId };
    };

    const getNavigationOptions = (pathname) => {
        if (!props.sportTree.fetched || props.sportTree.error) {
            return null;
        }

        let navigationOptions = {
            items: [],
            selectedSport: null,
            selectedId: 'none',
        };

        if (showGeneralNavigation) {
            const generalNavigationOptions =
                getGeneralNavigationOptions() || {};

            navigationOptions = {
                ...navigationOptions,
                ...generalNavigationOptions,
            };
        } else {
            const sportPageNavigationOptions = getSportPageNavigationOptions(
                pathname
            );
            navigationOptions = {
                ...navigationOptions,
                ...sportPageNavigationOptions,
            };
        }

        return (
            <ViewHorizontalNavigation
                items={navigationOptions.items}
                showBackBtn={pathname[1] !== '' && pathname[1] !== undefined}
                backBtnHandler={onClickBackBtn}
                selectedSport={navigationOptions.selectedSport}
                selectedId={navigationOptions.selectedId}
                clickHandler={horizontalNavClickHandler}
            />
        );
    };

    const searchLiveEventList = () => {
        return props.liveEvents.array.filter((event) => {
            const searchText = props.searchText.trim().toLowerCase();
            return liveEventSearchFileds.some(
                (key) =>
                    typeof event[key] === 'string' &&
                    event[key].toLowerCase().includes(searchText)
            );
        });
    };

    const spinner = <ViewSpinner />;
    /*const highlightView = props.highlightStatus ? (
        <ViewHighlight onCloseHandler={onCloseHighlightHandler} />
    ) : null;*/

    const searchInputView = (
        <LoadableContainer
            shouldRender={!isLoginOpen()}
            isLoading={isInitialPageLoad}
            skeleton={<SearchFieldSkeleton />}
        >
            <ViewSearchBox
                autofocus={true}
                showBackBtn={pathname[1] !== '' && isMobile}
                backBtnHandler={onClickBackBtn}
                onSearchTextHandler={onSearchTextHandler}
                value={props.searchText}
            />
        </LoadableContainer>
    );

    if (props.searchText && props.searchText.length >= SEARCH_LETTER_COUNT) {
        return (
            <section
                className={classNames('home-layout', {
                    mobile: isMobile,
                    ph20: !isMobile,
                })}
            >
                {/*!//TODO show after type in search*/}
                {searchInputView}
                {props.overviewSearchEvents.pending ? (
                    <div className="search-box-spinner">{spinner}</div>
                ) : (
                    <>
                        <ViewListToolbar title="Live" />
                        <ViewEventList
                            events={ModelService.getSportTree(
                                props.sportTree.sportData,
                                searchLiveEventList(),
                                'array',
                                0,
                                null,
                                'sportId'
                            )}
                        />

                        <ViewListToolbar title="Pre" />
                        <ViewEventList
                            events={ModelService.getSportTree(
                                props.sportTree.sportData,
                                props.overviewSearchEvents.data,
                                'array',
                                0,
                                null,
                                'sportId'
                            )}
                        />
                    </>
                )}
            </section>
        );
    } else {
        const compareWith = CAMPAIGNS_COMPARE_WITH;

        const horizontalNavigation = getNavigationOptions(pathname);
        const isHorizontalNavigationLoading =
            isInitialPageLoad ||
            (!showGeneralNavigation &&
                pathname[2] !== ANOTHER_GROUPS_PATH &&
                !props.popularEvents.fetched);
        const navigationView = (
            <LoadableContainer
                shouldRender={true}
                isLoading={isHorizontalNavigationLoading}
                skeleton={<HorizontalNavigationSkeleton />}
            >
                {horizontalNavigation}
            </LoadableContainer>
        );

        const listViewContent = getView(pathname);

        const checkIsListViewLoading = () => {
            if (isAnotherPage) {
                return false;
            } else if (isRestenGroup) {
                return isGameItemsLoading;
            } else if (isSportPage) {
                return !props.overviewEvents.fetched;
            } else {
                return !props.popularEvents.fetched;
            }
        };

        const isListViewContentLoading = checkIsListViewLoading();

        const viewEventListSkeleton =
            isAnotherPage || isRestenGroup ? (
                <AndetPageSkeleton />
            ) : (
                <ViewEventListSkeleton keyword="list_view" rowCount={6} />
            );

        const listView = (
            <LoadableContainer
                shouldRender={true}
                isLoading={isInitialPageLoad || isListViewContentLoading}
                skeleton={viewEventListSkeleton}
            >
                {listViewContent}
            </LoadableContainer>
        );

        const liveEventsContent = getLiveEventsView();
        const liveEventsView = (
            <LoadableContainer
                shouldRender={hasHomePage}
                isLoading={
                    isInitialPageLoad ||
                    !props.liveEvents.fetched ||
                    !isInitialPopularLiveReady
                }
                skeleton={
                    <ViewEventListSkeleton
                        keyword="popular_live"
                        rowCount={4}
                    />
                }
            >
                {liveEventsContent}
            </LoadableContainer>
        );

        let filteredCampaigns = props.campaigns.fetched
            ? props.campaigns?.data.filter((campaign) => {
                  return compareWith.indexOf(campaign.platform) > -1;
              })
            : [];

        const viewListCampaigns = (
            <div className="secondary-block-campagn-container">
                {!props.campaigns.fetched ? (
                    <CampaignSkeleton itemCount={2} />
                ) : (
                    filteredCampaigns.map((item, index) => (
                        <ViewCampaignListItem key={index} campaign={item} />
                    ))
                )}
            </div>
        );

        return (
            <section
                className={classNames('home-layout', {
                    mobile: isMobile,
                })}
            >
                {isMobile && (
                    <>
                        {searchInputView}
                        {navigationView}
                        {hasHomePage && (
                            <>
                                <EventsHighlights />
                                <Combos />
                                <CustomBetRecommendation auth={props.auth} />
                            </>
                        )}
                        {listView}
                        {liveEventsView}
                    </>
                )}

                {isDesktop && (
                    <div className="main-content-container">
                        <div className="main-block">
                            <div className="main-search-block">
                                {searchInputView}
                            </div>
                            {navigationView}
                            {hasHomePage && (
                                <>
                                    <EventsHighlights />
                                    <Combos />
                                    <CustomBetRecommendation
                                        auth={props.auth}
                                    />
                                </>
                            )}
                            {listView}
                            {liveEventsView}
                        </div>
                        <div className="secondary-block">
                            <div className="secondary-search-block">
                                {searchInputView}
                            </div>
                            {viewListCampaigns}
                        </div>
                    </div>
                )}
            </section>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        ui: state.ui,
        preEvents: state.preEvents,
        liveEvents: state.liveEvents,
        popularEvents: state.popularEvents,
        overviewEvents: state.overviewEvents,
        sportTree: state.sportTree,
        vaixEvents: state.vaixEvents,
        searchText: state.uiSportOverview.searchText,
        overviewSearchEvents: state.overviewSearchEvents,
        routing: state.routing,
        auth: state.auth,
        campaigns: state.campaigns,
        highlightStatus: state.ui.highlightStatus,
        modals: state.ui.modals,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        popularEventsActions: bindActionCreators(
            PopularEventsActions,
            dispatch
        ),
        overviewEventsActions: bindActionCreators(
            OverviewEventsActions,
            dispatch
        ),
        uiSportOverviewActions: bindActionCreators(
            UiSportOverviewActions,
            dispatch
        ),
        addVaixLiveFavoriteEvents: bindActionCreators(
            AddVaixLiveFavoriteEvents,
            dispatch
        ),
        setLiveVaixPopularFetchedStatus: bindActionCreators(
            SetLiveVaixPopularFetchedStatus,
            dispatch
        ),
        getLivePopularVaixEvents: bindActionCreators(
            GetLivePopularVaixEvents,
            dispatch
        ),
        trackClickEvent: bindActionCreators(
            TrackingEventActions.trackClickEvent,
            dispatch
        ),
        trackImpressionEvent: bindActionCreators(
            TrackingEventActions.trackImpressionEvent,
            dispatch
        ),
        showModal: bindActionCreators(ShowModal, dispatch),
        hideModal: bindActionCreators(HideModal, dispatch),
        setLiveScoreStatus: bindActionCreators(SetLiveScoreStatus, dispatch),
        setHighlightStatus: bindActionCreators(SetHighlightStatus, dispatch),
        vaixEventsActions: bindActionCreators(VaixEventsAction, dispatch),
        authActions: bindActionCreators(AuthActions, dispatch),
        sportTreeActions: bindActionCreators(SportTreeActions, dispatch),
        setDannmarkItems: bindActionCreators(SetDannmarkItems, dispatch),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HomeContainerNew);
